export default "__VITE_ASSET__zw_aydhP__"